/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/backend/affordability-limits/logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Index endpoint for all limit changes
         * @description Can be limited to a single user by sending field filter with the value of ['user_id' => '3]
         */
        get: operations["backend.affordability-limits.log.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/high-risk-limits/logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["backend.high-risk-limits.logs.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/limits": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Index endpoint for all limits
         * @description Can be limited to a single user by sending field filter with the value of ['user_id' => '3]
         */
        get: operations["backend.limits.index"];
        put?: never;
        /**
         * Endpoint for employees to manually update or create limits for a user.
         *     This endpoint requires that the name of the employee performing the update is sent with the data for audit purposes.
         *     TODO: Remove this endpoint when other services use the new PlayerLimitController::setPeriodicLimits() instead https://trello.com/c/Da19X2LD/2373-fjern-legacy-endpoint-til-at-s%C3%A6tte-limits
         */
        post: operations["backend.limits.updateOrCreate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/limits/block": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Creates a limit block record, which stores the fact that a user
         *     was blocked from performing an action they have attempted - Due to a limit
         */
        post: operations["backend.limits.blocks.store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/limits/blocks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Index endpoint for all limit blocks
         * @description Can be limited to a single user by sending field filter with the value of ['player_id' => '1ec9414c-232a-6b00-b3c8-9e6bdeced846']
         */
        get: operations["backend.limits.blocks.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/limits/logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Index endpoint for all limit changes
         * @description Can be limited to a single user by sending field filter with the value of ['user_id' => '3]
         */
        get: operations["backend.limits.log.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/mentor/limit-changes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns the total number of limit changes made from a given from and to period */
        get: operations["backend.mentor.limit-changes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/overdue-compliance-limits": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Returns one row per player who has at least one overdue limit,
         *     with the earliest (minimum) expired-at timestamp for that player
         */
        get: operations["backend.overdue-compliance-limits.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/pending-limits": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Index endpoint for all pending limits
         * @description Can be limited to a single user by sending field filter with the value of ['user_id' => '3]
         */
        get: operations["backend.pending-limits.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/pending-limits/logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Index endpoint for all limit changes
         * @description Can be limited to a single user by sending field filter with the value of ['user_id' => '3]
         */
        get: operations["backend.pending-limits.log.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/affordability/trigger": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Gets and persists the player's affordability score */
        post: operations["backend.player.affordability.trigger"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/auto-compliance-limit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["backend.player.auto-compliance-limit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/deposit-attempt": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Attempts to make a deposit, considering the player's limits */
        post: operations["backend.player.deposit-attempt"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/enabled-limit-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns whether each limit type is enabled for a specific player */
        get: operations["backend.player.get-enabled-limit-types"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/financial-score/recheck": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Rechecks the player's financial vulnerability, and affordability when applicable, and returns the resulting limit */
        post: operations["backend.player.financial-score.recheck"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/financial-vulnerability/trigger": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Gets and persists the player's financial vulnerability score */
        post: operations["backend.player.financial-vulnerability.trigger"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/get-limits": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["backend.player.get-limits"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/has-bebettor-failed-check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["backend.player.has-bebettor-failed-check"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/high-risk-limits/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["backend.player.high-risk-limits.stats"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/periodic-limits": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["backend.player.get-periodic-limits"];
        put?: never;
        post: operations["backend.player.set-periodic-limits"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/periodic-limits/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["backend.player.get-periodic-limits.history"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/periodic-limits/progress": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["backend.player.get-periodic-limit-progress"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/periodic-limits/snapshot": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets a snapshot of the player's periodic limits at a given date, along with their active status */
        get: operations["backend.player.get-periodic-limits.snapshot"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/screening-reports/{checkId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["backend.player.screeningReports.show"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/wager-attempt": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Attempts to place a wager, considering the player's limits */
        post: operations["backend.player.wager-attempt"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/player/{playerId}/wager-prerequisites": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["backend.player.wager-prerequisites"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/backend/user/{playerId}/limits/{limitType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns a players current limit status for a given limit type */
        get: operations["backend.user.limits.status"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/documentation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Handles the API request and renders the Swagger documentation view */
        get: operations["l5-swagger.default.api"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/oauth2-callback": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Handles the OAuth2 callback and retrieves the required file for the redirect */
        get: operations["l5-swagger.default.oauth2_callback"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/limits/{limitType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns the users current limits */
        get: operations["limit.get-current-limits"];
        put?: never;
        /** Updates the users limits. Updates will be put in pending mode, if they increase the limit */
        post: operations["limit.set-limits"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/limits/{limitType}/confirm": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Will apply all pending deposit limits which are ready to be applied
         * @description Some countries require the user to reaffirm their pending deposit limit updates,
         *     before they can be applied.
         *
         *     This endpoint is only relevant for those countries, since the update is automatically applied otherwise.
         */
        post: operations["limit.confirm-pending-limits"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/limits/{limitType}/sliders": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns the slider options */
        get: operations["limit.sliders"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/limits/{limitType}/validate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Validates the users limits */
        post: operations["limit.validate-limits"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/limits/affordability-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["limit.get-affordability-status"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/limits/config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns limit configs */
        get: operations["limit.get-config"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/limits/reminder-preference": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["limit.get-reminder-preference"];
        put?: never;
        post: operations["limit.set-reminder-preference"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /** AffordabilityLimitStatus */
        AffordabilityLimitStatus: {
            limitValue: string | null;
            netLoss: string | null;
            progressPercentage: string | null;
        };
        /** AutoComplianceLimitRequest */
        AutoComplianceLimitRequest: {
            brand: components["schemas"]["Brand"];
            createdBy: string;
            period: components["schemas"]["LimitPeriod"];
            reason: string;
            type: components["schemas"]["LimitType"];
            value: number;
        };
        /**
         * Brand
         * @enum {string}
         */
        Brand: Brand;
        /** DepositAttemptRequest */
        DepositAttemptRequest: {
            depositAmount: number;
        };
        /** DepositAttemptResponse */
        DepositAttemptResponse: {
            blockingLimit: components["schemas"]["DepositLimit"] | null;
        };
        /** DepositLimit */
        DepositLimit: {
            category: components["schemas"]["LimitCategory"];
            exceededAmount: string;
            limitSetBy: components["schemas"]["LimitSetBy"] | null;
            maxesOutLimit: boolean;
            shouldBlock: boolean;
            value: string;
        };
        /** EmployeeLimitStatus */
        EmployeeLimitStatus: {
            /** Format: date-time */
            expiresAt: string | null;
            hasSoftExpiry: boolean;
            period: components["schemas"]["LimitPeriod"];
            remaining: string;
            /** Format: date-time */
            setAt: string;
            setBy: components["schemas"]["LimitSetBy"];
            type: components["schemas"]["LimitType"];
            value: string;
        };
        /**
         * FinancialScoreLimitType
         * @enum {string}
         */
        FinancialScoreLimitType: FinancialScoreLimitType;
        /** FinancialScoreTriggerRequest */
        FinancialScoreTriggerRequest: {
            /** @default false */
            force?: boolean;
            reason: string;
        };
        /**
         * GetConfigResponse
         * @description The response of LimitController::getConfig().
         *
         *     The frontend reads the config for each enabled limit type (depositLimits and/or
         *     lossLimits - both can be enabled at the same time) plus the highRisks block.
         *     Giving this a concrete type means the generated OpenAPI client types the 200
         *     body as this object instead of `string`.
         */
        GetConfigResponse: {
            depositLimits: components["schemas"]["LimitConfigStatus"];
            highRisks: components["schemas"]["HighRisksStatus"];
            lossLimits: components["schemas"]["LimitConfigStatus"];
        };
        /** GetEnabledLimitTypesRequest */
        GetEnabledLimitTypesRequest: Record<string, never>;
        /** GetHighRiskLimitStatsForPlayerRequest */
        GetHighRiskLimitStatsForPlayerRequest: Record<string, never>;
        /** GetHighRiskLimitStatsForPlayerResponse */
        GetHighRiskLimitStatsForPlayerResponse: {
            highRiskLimitStats: components["schemas"]["HighRIskLimitStat"][];
        };
        /** GetLimitStatusesResponse */
        GetLimitStatusesResponse: {
            limits: (components["schemas"]["PlayerLimitStatus"] | components["schemas"]["EmployeeLimitStatus"])[];
        };
        /** GetPeriodicLimitData */
        GetPeriodicLimitData: {
            /** Format: date-time */
            created_at: string;
            created_by_employee: string | null;
            /** Format: date-time */
            expires_at: string | null;
            has_soft_expiry: boolean;
            id: string;
            is_active: boolean;
            is_revert: boolean;
            limit: string | null;
            period: components["schemas"]["LimitPeriod"];
            player_id: string;
            reason: string | null;
            set_by: components["schemas"]["LimitSetBy"];
            type: components["schemas"]["LimitType"];
            /** Format: date-time */
            updated_at: string;
        };
        /** GetPeriodicLimitHistoryRequest */
        GetPeriodicLimitHistoryRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
            type: components["schemas"]["LimitType"];
        };
        /** GetPeriodicLimitHistoryResponse */
        GetPeriodicLimitHistoryResponse: {
            complianceLimits: components["schemas"]["PeriodicLimitHistoryEntry"][];
            playerLimits: components["schemas"]["PeriodicLimitHistoryEntry"][];
        };
        /** GetPeriodicLimitProgressesRequest */
        GetPeriodicLimitProgressesRequest: {
            type: components["schemas"]["LimitType"];
        };
        /** GetPeriodicLimitsRequest */
        GetPeriodicLimitsRequest: {
            type: components["schemas"]["LimitType"];
        };
        /** GetPeriodicLimitsResponse */
        GetPeriodicLimitsResponse: {
            limits: components["schemas"]["GetPeriodicLimitData"][];
        };
        /** GetPeriodicLimitsSnapshotRequest */
        GetPeriodicLimitsSnapshotRequest: {
            /** Format: date-time */
            dateTime: string;
        };
        /** GetPlayerLimitsRequest */
        GetPlayerLimitsRequest: {
            type: components["schemas"]["LimitType"];
        };
        /** HasBebettorFailedCheckRequest */
        HasBebettorFailedCheckRequest: Record<string, never>;
        /** HasBebettorFailedCheckResponse */
        HasBebettorFailedCheckResponse: {
            hasFailedCheck: boolean;
        };
        /** HighRIskLimitStat */
        HighRIskLimitStat: {
            highRiskType: components["schemas"]["HighRiskType"];
            limitType: components["schemas"]["LimitType"];
            limitValue: string;
            progress: string;
            /** Format: date-time */
            startedAt: string;
        };
        /**
         * HighRisksStatus
         * @description The high-risk status block of the getConfig() response.
         *
         *     Mirrors the array assigned to $response['highRisks'] in LimitController::getConfig().
         */
        HighRisksStatus: {
            depositLimitReached: boolean;
        };
        /**
         * HighRiskType
         * @enum {string}
         */
        HighRiskType: HighRiskType;
        /** IndexRequest */
        IndexRequest: {
            /**
             * @default [
             *       "*"
             *     ]
             */
            columns?: string[];
            /** @default [] */
            filter?: {
                [key: string]: unknown;
            };
            /** @default 1 */
            page?: number;
            /** @default 50 */
            perPage?: number;
        };
        /** LegacyLimitStatuses */
        LegacyLimitStatuses: {
            [key: string]: unknown;
        };
        /** LimitBlockStoreRequest */
        LimitBlockStoreRequest: {
            period: components["schemas"]["LimitCategory"];
            playerId: string;
            /** Format: date-time */
            timestamp: string;
            type: components["schemas"]["LimitType"];
        };
        /**
         * LimitCategory
         * @enum {string}
         */
        LimitCategory: LimitCategory;
        /** LimitChange */
        LimitChange: {
            limit: string | null;
            previousLimit: string | null;
            status: components["schemas"]["LimitChangeStatus"];
        };
        /**
         * LimitChangeStatus
         * @enum {string}
         */
        LimitChangeStatus: LimitChangeStatus;
        /**
         * LimitConfigStatus
         * @description The per-limit-type config status returned by LimitController::getConfig().
         *
         *     Mirrors exactly the array built for each LimitType inside getConfig(), so the
         *     generated OpenAPI client can type the response as an object instead of `string`.
         */
        LimitConfigStatus: {
            canPendingBeConfirmed: boolean;
            enabled: boolean;
            pendingHours: number;
            prompt: components["schemas"]["LimitPromptAt"];
            requirement: components["schemas"]["LimitRequirement"];
            requiresUserConfirmation: boolean;
            type: components["schemas"]["LimitType"];
            userHasAnyLimit: boolean;
        };
        /** LimitData */
        LimitData: {
            limit?: number | null;
            period: components["schemas"]["LimitPeriod"];
            /** Format: uuid */
            playerId: string;
            type: components["schemas"]["LimitType"];
        };
        /**
         * LimitErrorResponse
         * @description The error response body returned by the public limit endpoints on a 400.
         *
         *     The controller always returns `success: false` and `message` on a 400.
         *     When the failure is a validation error (LimitValidationException), it also
         *     includes `errors` - a map of field keys to arrays of error messages.
         *
         *     `errors` is typed `array|Optional` (defaulting to `Optional::create()`) so
         *     that plain LimitException responses omit the key entirely (matching the
         *     pre-DTO wire format), while LimitValidationException responses include it
         *     with the validation details. Use `instanceof Optional` to check absence.
         */
        LimitErrorResponse: {
            /** @description Validation errors, present only for LimitValidationException */
            errors?: {
                [key: string]: string[];
            };
            message: string;
            success: boolean;
        };
        /**
         * LimitPeriod
         * @enum {string}
         */
        LimitPeriod: LimitPeriod;
        /** LimitProgress */
        LimitProgress: {
            daily: string;
            monthly: string;
            weekly: string;
        };
        /**
         * LimitPromptAt
         * @enum {string}
         */
        LimitPromptAt: LimitPromptAt;
        /**
         * LimitReminderType
         * @enum {string}
         */
        LimitReminderType: LimitReminderType;
        /**
         * LimitRequirement
         * @enum {string}
         */
        LimitRequirement: LimitRequirement;
        /**
         * LimitSetBy
         * @enum {string}
         */
        LimitSetBy: LimitSetBy;
        /**
         * LimitType
         * @enum {string}
         */
        LimitType: LimitType;
        /** MentorLimitChangesRequest */
        MentorLimitChangesRequest: {
            /** Format: date-time */
            from: string;
            /** Format: date-time */
            to: string;
        };
        /** PeriodicLimit */
        PeriodicLimit: {
            id: string;
            limit_value: string | null;
        };
        /** PeriodicLimitHistoryEntry */
        PeriodicLimitHistoryEntry: {
            createdByEmployee: string | null;
            daily: components["schemas"]["LimitChange"];
            monthly: components["schemas"]["LimitChange"];
            /** Format: date-time */
            setAt: string;
            weekly: components["schemas"]["LimitChange"];
        };
        /** PlayerLimits */
        PlayerLimits: {
            daily: components["schemas"]["PeriodicLimit"] | null;
            high_risk_aml: components["schemas"]["TemporalLimit"] | null;
            high_risk_rg: components["schemas"]["TemporalLimit"] | null;
            monthly: components["schemas"]["PeriodicLimit"] | null;
            weekly: components["schemas"]["PeriodicLimit"] | null;
        };
        /** PlayerLimitStatus */
        PlayerLimitStatus: {
            canBeConfirmed: boolean;
            /** Format: date-time */
            pendingUntil: string | null;
            pendingValue: string | null;
            period: components["schemas"]["LimitPeriod"];
            remaining: string;
            /** Format: date-time */
            setAt: string;
            setBy: components["schemas"]["LimitSetBy"];
            type: components["schemas"]["LimitType"];
            value: string;
        };
        /** RecheckFinancialScoreRequest */
        RecheckFinancialScoreRequest: {
            reason: string;
        };
        /** RecheckFinancialScoreResponse */
        RecheckFinancialScoreResponse: {
            changed: boolean;
            checked: boolean;
            /** Format: date-time */
            financialVulnerabilityCheckedAt: string | null;
            hasFailedCheck: boolean;
            limitType: components["schemas"]["FinancialScoreLimitType"] | null;
            limitValue: string | null;
            previousLimitType: components["schemas"]["FinancialScoreLimitType"] | null;
            previousLimitValue: string | null;
        };
        /** ReminderPreferenceData */
        ReminderPreferenceData: {
            /** Format: date-time */
            notify_at: string | null;
            recurrence_months: number;
            reminder_type: components["schemas"]["LimitReminderType"] | null;
        };
        /** Report */
        Report: {
            content: components["schemas"]["ReportContentItem"][];
            contentModel: string;
        };
        /** ReportContentItem */
        ReportContentItem: {
            description: string;
            id: string;
            name: string;
            parameters: components["schemas"]["ReportContentParameterItem"][];
        };
        /** ReportContentParameterItem */
        ReportContentParameterItem: {
            description: string;
            id: string;
            name: string;
            value: string | null;
        };
        /** ReportResponse */
        ReportResponse: {
            checkId: string;
            checkTime: string;
            customerId: string;
            report: components["schemas"]["Report"];
            requestId: string;
        };
        /** SetLimitsRequest */
        SetLimitsRequest: {
            brand: components["schemas"]["Brand"];
            limits: {
                [key: string]: string;
            };
        };
        /**
         * SetLimitsResponse
         * @description The success response of LimitController::setLimits().
         *
         *     `limits` is the LegacyLimitStatuses structure returned by
         *     GetLimitService::getLimitStatuses() - an object keyed by period (DAILY/WEEKLY/
         *     MONTHLY), each value being a LegacyLimitStatus. The @property-read annotation
         *     below teaches Scramble the actual emitted shape, since LegacyLimitStatuses is a
         *     plain JsonSerializable class that Scramble cannot introspect directly. Using a
         *     class-level @property-read avoids shadowing the constructor's PHP type hint.
         */
        SetLimitsResponse: {
            limits: string;
            success: boolean;
        };
        /** SetPeriodicLimitData */
        SetPeriodicLimitData: {
            hasSoftExpiry: boolean;
            period: components["schemas"]["LimitPeriod"];
            value?: number | null;
        };
        /** SetPeriodicLimitsRequest */
        SetPeriodicLimitsRequest: {
            brand: components["schemas"]["Brand"];
            employeeName: string;
            /** Format: date-time */
            expiresAt?: string | null;
            limits: components["schemas"]["SetPeriodicLimitData"][];
            reason: string;
            type: components["schemas"]["LimitType"];
        };
        /** SetReminderPreferenceRequest */
        SetReminderPreferenceRequest: {
            /** @enum {integer} */
            recurrence_months: SetReminderPreferenceRequestRecurrence_months;
        };
        /** ShowScreeningReportRequest */
        ShowScreeningReportRequest: Record<string, never>;
        /** TemporalLimit */
        TemporalLimit: {
            /** Format: date-time */
            created_at: string;
            id: string;
            limit_value: string;
        };
        /** UpdateOrCreateLimitsRequest */
        UpdateOrCreateLimitsRequest: {
            brand: components["schemas"]["Brand"];
            employeeName: string;
            limits: components["schemas"]["LimitData"][];
        };
        /** UuidV6 */
        UuidV6: string;
        /** ValidateLimitsRequest */
        ValidateLimitsRequest: {
            limits: {
                [key: string]: number;
            };
        };
        /** WagerAttemptRequest */
        WagerAttemptRequest: {
            netLosses?: string[] | null;
            wagerAmount: string;
        };
        /** WagerAttemptResponse */
        WagerAttemptResponse: {
            blockingLimit: components["schemas"]["WagerLimit"] | null;
        };
        /** WagerLimit */
        WagerLimit: {
            category: components["schemas"]["LimitCategory"];
            exceededAmount: string;
            isBlocking: boolean;
            limitSetBy: components["schemas"]["LimitSetBy"] | null;
            shouldBlock: boolean;
            triggersAffordabilityCheck: boolean;
            value: string;
        };
        /** WagerPrerequisitesRequest */
        WagerPrerequisitesRequest: Record<string, never>;
        /** WagerPrerequisitesResponse */
        WagerPrerequisitesResponse: {
            affordabilityCutOffDayOfMonth: number;
            limitCategories: components["schemas"]["LimitCategory"][];
        };
    };
    responses: {
        /** @description Not found */
        ModelNotFoundException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description Error overview. */
                    message: string;
                };
            };
        };
        /** @description Validation error */
        ValidationException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description A detailed description of each field that failed validation. */
                    errors: {
                        [key: string]: string[];
                    };
                    /** @description Errors overview. */
                    message: string;
                };
            };
        };
    };
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    "backend.affordability-limits.log.index": {
        parameters: {
            query?: {
                columns?: string[];
                filter?: {
                    [key: string]: unknown;
                };
                page?: number;
                perPage?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.high-risk-limits.logs.index": {
        parameters: {
            query?: {
                columns?: string[];
                filter?: {
                    [key: string]: unknown;
                };
                page?: number;
                perPage?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.limits.index": {
        parameters: {
            query?: {
                columns?: string[];
                filter?: {
                    [key: string]: unknown;
                };
                page?: number;
                perPage?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.limits.updateOrCreate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `UpdateOrCreateLimitsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateOrCreateLimitsRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        success: boolean;
                    } | string;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.limits.blocks.store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `LimitBlockStoreRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["LimitBlockStoreRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        success: boolean;
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.limits.blocks.index": {
        parameters: {
            query?: {
                columns?: string[];
                filter?: {
                    [key: string]: unknown;
                };
                page?: number;
                perPage?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.limits.log.index": {
        parameters: {
            query?: {
                columns?: string[];
                filter?: {
                    [key: string]: unknown;
                };
                page?: number;
                perPage?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.mentor.limit-changes": {
        parameters: {
            query: {
                from: string;
                to: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown[];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.overdue-compliance-limits.index": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        min_expires_at: string;
                        player_id: components["schemas"]["UuidV6"];
                    }[];
                };
            };
        };
    };
    "backend.pending-limits.index": {
        parameters: {
            query?: {
                columns?: string[];
                filter?: {
                    [key: string]: unknown;
                };
                page?: number;
                perPage?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.pending-limits.log.index": {
        parameters: {
            query?: {
                columns?: string[];
                filter?: {
                    [key: string]: unknown;
                };
                page?: number;
                perPage?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.affordability.trigger": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        /** @description `FinancialScoreTriggerRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["FinancialScoreTriggerRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown[];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.auto-compliance-limit": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        /** @description `AutoComplianceLimitRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["AutoComplianceLimitRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.deposit-attempt": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        /** @description `DepositAttemptRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["DepositAttemptRequest"];
            };
        };
        responses: {
            /** @description `DepositAttemptResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DepositAttemptResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.get-enabled-limit-types": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string[];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.financial-score.recheck": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        /** @description `RecheckFinancialScoreRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["RecheckFinancialScoreRequest"];
            };
        };
        responses: {
            /** @description `RecheckFinancialScoreResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RecheckFinancialScoreResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.financial-vulnerability.trigger": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        /** @description `FinancialScoreTriggerRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["FinancialScoreTriggerRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": unknown[];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.get-limits": {
        parameters: {
            query: {
                type: components["schemas"]["LimitType"];
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `PlayerLimits` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerLimits"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.has-bebettor-failed-check": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `HasBebettorFailedCheckResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HasBebettorFailedCheckResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.high-risk-limits.stats": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GetHighRiskLimitStatsForPlayerResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetHighRiskLimitStatsForPlayerResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.get-periodic-limits": {
        parameters: {
            query: {
                type: components["schemas"]["LimitType"];
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GetPeriodicLimitsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetPeriodicLimitsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.set-periodic-limits": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        /** @description `SetPeriodicLimitsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SetPeriodicLimitsRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.get-periodic-limits.history": {
        parameters: {
            query: {
                from?: string | null;
                to?: string | null;
                type: components["schemas"]["LimitType"];
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GetPeriodicLimitHistoryResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetPeriodicLimitHistoryResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.get-periodic-limit-progress": {
        parameters: {
            query: {
                type: components["schemas"]["LimitType"];
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `LimitProgress` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LimitProgress"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.get-periodic-limits.snapshot": {
        parameters: {
            query: {
                dateTime: string;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GetPeriodicLimitsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetPeriodicLimitsResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.screeningReports.show": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                checkId: string;
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ReportResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportResponse"];
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
            /** @description An error */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /**
                         * @description Error overview.
                         * @example Screening report is temporarily unavailable.
                         */
                        message: string;
                    };
                };
            };
        };
    };
    "backend.player.wager-attempt": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        /** @description `WagerAttemptRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["WagerAttemptRequest"];
            };
        };
        responses: {
            /** @description `WagerAttemptResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WagerAttemptResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.player.wager-prerequisites": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `WagerPrerequisitesResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WagerPrerequisitesResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "backend.user.limits.status": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The limit type ID */
                limitType: components["schemas"]["LimitType"];
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegacyLimitStatuses"];
                };
            };
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "l5-swagger.default.api": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
        };
    };
    "l5-swagger.default.oauth2_callback": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
        };
    };
    "limit.get-current-limits": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The limit type ID */
                limitType: components["schemas"]["LimitType"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GetLimitStatusesResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetLimitStatusesResponse"];
                };
            };
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "limit.set-limits": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The limit type ID */
                limitType: components["schemas"]["LimitType"];
            };
            cookie?: never;
        };
        /** @description `SetLimitsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SetLimitsRequest"];
            };
        };
        responses: {
            /** @description `SetLimitsResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SetLimitsResponse"] | string;
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "limit.confirm-pending-limits": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The limit type ID */
                limitType: components["schemas"]["LimitType"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        success: boolean;
                    };
                };
            };
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "limit.sliders": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The limit type ID */
                limitType: components["schemas"]["LimitType"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "limit.validate-limits": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The limit type ID */
                limitType: components["schemas"]["LimitType"];
            };
            cookie?: never;
        };
        /** @description `ValidateLimitsRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ValidateLimitsRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        errors: {
                            [key: string]: string[];
                        };
                        success: boolean;
                    };
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "limit.get-affordability-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `AffordabilityLimitStatus` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AffordabilityLimitStatus"];
                };
            };
        };
    };
    "limit.get-config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GetConfigResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetConfigResponse"];
                };
            };
        };
    };
    "limit.get-reminder-preference": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ReminderPreferenceData` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReminderPreferenceData"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Limit reminders are not enabled";
                    };
                };
            };
        };
    };
    "limit.set-reminder-preference": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `SetReminderPreferenceRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SetReminderPreferenceRequest"];
            };
        };
        responses: {
            /** @description `ReminderPreferenceData` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReminderPreferenceData"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Limit reminders are not enabled";
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
}
export enum Brand {
    spilnu = "spilnu",
    happytiger = "happytiger",
    spinking = "spinking",
    bingoburst = "bingoburst",
    luxcasino = "luxcasino",
    sweetspin = "sweetspin",
    jackpotfisher = "jackpotfisher",
    spinnow = "spinnow",
    crushit = "crushit"
}
export enum FinancialScoreLimitType {
    fv_v1 = "fv_v1",
    fv_v2 = "fv_v2",
    fv_v3 = "fv_v3",
    fv_v4 = "fv_v4",
    fv_pass = "fv_pass",
    al_red = "al_red",
    al_amber = "al_amber",
    al_green = "al_green"
}
export enum HighRiskType {
    RG = "RG",
    AML = "AML"
}
export enum LimitCategory {
    DAILY = "DAILY",
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY",
    HIGH_RISK_AML = "HIGH_RISK_AML",
    HIGH_RISK_RG = "HIGH_RISK_RG",
    AFFORDABILITY = "AFFORDABILITY"
}
export enum LimitChangeStatus {
    increased = "increased",
    decreased = "decreased",
    unchanged = "unchanged"
}
export enum LimitPeriod {
    DAILY = "DAILY",
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY"
}
export enum LimitPromptAt {
    PLAY = "PLAY",
    NEVER = "NEVER",
    SIGNUP = "SIGNUP",
    DEPOSIT = "DEPOSIT"
}
export enum LimitReminderType {
    annual = "annual",
    recurring = "recurring"
}
export enum LimitRequirement {
    OPTIONAL = "OPTIONAL",
    SINGLE = "SINGLE",
    ALL = "ALL"
}
export enum LimitSetBy {
    PLAYER = "PLAYER",
    EMPLOYEE = "EMPLOYEE"
}
export enum LimitType {
    depositLimits = "depositLimits",
    lossLimits = "lossLimits"
}
export enum SetReminderPreferenceRequestRecurrence_months {
    Value1 = 1,
    Value3 = 3,
    Value6 = 6
}
